import FireBaseHelperOwn from "../firebase";


import AppLogo from "../../../Icons/logos/App-logo.png";
import iconCharcoalDarkSaved from "../../../Icons/icons-charcoal-dark/saved.png";
import iconCharcoalDarkliked from "../../../Icons/icons-charcoal-dark/liked.png";
import iconCharcoalDarkSave from "../../../Icons/icons-charcoal-dark/save.png";
import iconCharcoalNotify from "../../../Icons/icons-charcoal-dark/notify.png";
import iconCharcoalNotNotify from "../../../Icons/icons-charcoal-dark/not-notify.png";

import generateHtml from "./generate-html";
import StackDisplay from "../stack-display/display";
import spinner from "../spinner";
import firebase from "../firebase";

import handleAccount from "../register/handle-account";
import register from "../register/register";

import GENRALHELPERS from "../GENRAL-HELPERS";
import displayListingGenerateHtml from "../display-listing/generate-html";

import allHandeling from "../handeling-all-displays/all-handeling";
import display from "../stack-display/display";
import shareNow from "../share-now/share-now";

import iconBlackSave from "../../../Icons/icons-black/save.png";
import iconBlackSaved from "../../../Icons/icons-black/saved.png";
import B3B3B3 from "../../../Icons/icons-gray/B3B3B3.png";

import iconYellowSave from "../../../Icons/NV/yellow/save.png";
import iconYellowSaved from "../../../Icons/NV/yellow/saved.png";
import NVBusinessEditor from "../business-page-editor/NV-business-editor";

class DisplayBusinessEach {
  #account;
  #interaction = false
  #lastVisibleDocForBusinessListings = null;
  #wasFinalDocForLoad = false;
  #currenBusinessData = null;
  #currentCategory = null;
  #bottomScrollDetectOnBusinessDisplayConActivated = false;
  #isLoadingLisitngForBusiness = false;
  #currentBusinessId = null;
  #contactInfoDispFunction = null
  #optionsDispFunction = null
  #listsOptionsDispFunction = null
  #listsEditDispFunction = null
  #currentListForAction = ''
  #catagoryImageChanged = false
  #editListsEventsInitialized = false;

  #oneTimeEventsInitialized = false;

  _getCurrentBusiness() {
    return this.#currenBusinessData;
  }

  _detectScrollDirection(id, callback) {
    const container = document.getElementById(id);
    console.log(container);
    let lastScrollTop = container.scrollTop;

    container.addEventListener("scroll", () => {
      const currentScrollTop = container.scrollTop;
      const diff = currentScrollTop - lastScrollTop;

      if (currentScrollTop < 0) return;

      if (Math.abs(diff) > 50) {
        const direction = diff > 0 ? "down" : "up";
        // this._scrollDirectionDecide(direction);
        lastScrollTop = currentScrollTop; // reset after trigger
      }
    });
  }

  _returnMiniSpinner() {
    return `<svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 50 50"
      width="20"
      height="20"
      class="miniSpinneForButtons">
      <circle
        cx="25"
        cy="25"
        r="20"
        stroke="#2B2B2B"
        stroke-width="4"
        fill="none"
        stroke-dasharray="125.6"
        stroke-dashoffset="94.2"
        stroke-linecap="round">
        <animateTransform
          attributeName="transform"
          type="rotate"
          from="0 25 25"
          to="360 25 25"
          dur="0.8s"
          repeatCount="indefinite" />
      </circle>
    </svg>`;
  }

  _activateDetectScrollToBottom = (margin = 50) => {
    console.log("dectect bottom scroll called");
    if (this.#bottomScrollDetectOnBusinessDisplayConActivated) return;
    console.log("dectect bottom scroll activated");
    const businessListingsCon = document.getElementById(
      `nvBusinessEachCon1A`
    );
    if (!businessListingsCon) {
      console.log("Error: Container not found.");
      return;
    }

    // Add a scroll event listener
    businessListingsCon.addEventListener("scroll", async () => {
      const isScrolledToBottom =
        businessListingsCon.scrollHeight -
        businessListingsCon.scrollTop -
        businessListingsCon.clientHeight <=
        margin;

      if (isScrolledToBottom) {
        if (this.#wasFinalDocForLoad) {
          return;
        }
        this._loadMoreBusinessListings();
      } else {
      }
    });
    this.#bottomScrollDetectOnBusinessDisplayConActivated = true;
  };

  async _loadMoreBusinessListings(reset = false) {

    if (!this.#currenBusinessData) return
    const bussinessDisplayInsertListingsCon = document.getElementById(
      "bussinessDisplayInsertListingsCon"
    );
    const loadDocsNum = 12;
    if (this.#isLoadingLisitngForBusiness) return;
    this.#isLoadingLisitngForBusiness = true;
    if (reset) {
      this.#lastVisibleDocForBusinessListings = null;
      // this.#currentCategory = null;
    }

    console.warn(this.#currenBusinessData);
    const { listings, lastVisibleDoc } =
      await firebase._getRecentListingsWithFilter(
        this.#lastVisibleDocForBusinessListings,
        loadDocsNum,
        `businesses/${this.#currenBusinessData.businessId}/listings`,
        "listingMachineType",
        this.#currentCategory
      );
    this.#lastVisibleDocForBusinessListings = lastVisibleDoc;
    if (listings.length < loadDocsNum) {
      this.#wasFinalDocForLoad = true;
      console.warn("set to true");
    }

    if (listings.length > 0) {
      if (reset) {
        bussinessDisplayInsertListingsCon.innerHTML = "";
        console.log('FINDING SOME OTHER SOLUTION FOR THEI HERE');
        setTimeout(() => {
          if (!this.#interaction) return
          this._scrollToTopOfElement(
            "nvBusinessEachCon1A", 'bussinessDisplayHeaderCon1A'
          );
        }, 500)
      }
      for (const listing of listings) {
        const html = displayListingGenerateHtml._listingVerticalNV(
          listing,
          null,
          'business'
        );
        bussinessDisplayInsertListingsCon.insertAdjacentHTML("beforeend", html);
      }
    }
    this.#isLoadingLisitngForBusiness = false;
    this._activateDetectScrollToBottom();
  }




  _scrollToTopOfElement(scrollContainerId, scrollToId) {
    const container = document.getElementById(scrollContainerId);
    if (!container) {
      console.warn(`Element with ID "${scrollContainerId}" not found.`);
      return;
    }

    if (scrollToId) {
      const target = document.getElementById(scrollToId);
      if (target) {
        // Compute target position relative to the scroll container
        const containerRect = container.getBoundingClientRect();
        const targetRect = target.getBoundingClientRect();

        const scrollTop =
          container.scrollTop + (targetRect.top - containerRect.top);

        container.scrollTo({
          top: scrollTop,
          behavior: "smooth",
        });
      } else {
        console.warn(`Element with ID "${scrollToId}" not found.`);
      }
    } else {
      // Scroll to top of the container
      container.scrollTo({
        top: 0,
        behavior: "smooth",
      });
    }
  }


  _onContainerScroll(id) {
    const container = document.getElementById(id)
    if (!container) return;
    container.addEventListener('scroll', () => {
      this.#interaction = true
    });
  }

  _initializeContactButtonsShow(show = true) {
    const overlay = document.getElementById("nvBusinessContactEachCon12A");
    const panel = document.getElementById("nvBusinessContactEachCon12");

    if (!overlay || !panel) return;

    let startY = 0;
    let currentY = 0;
    let dragging = false;

    const resetPanel = () => {
      panel.style.transition = "";
      panel.style.transform = "";
    };

    const open = () => {
      resetPanel();
      overlay.classList.add("nvBusinessContactEachCon12AView");
      panel.classList.add("nvBusinessContactEachCon12View");
    };

    const close = () => {
      panel.style.transition = "transform 0.4s ease";
      panel.style.transform = "translateY(100%)";

      setTimeout(() => {
        panel.classList.remove("nvBusinessContactEachCon12View");
        overlay.classList.remove("nvBusinessContactEachCon12AView");
        resetPanel();
      }, 400);
    };

    // Initial state
    show ? open() : close();

    // Tap background to close
    overlay.addEventListener("click", (e) => {
      if (e.target === overlay) close();
    });

    /* ---------- DRAG (panel + overlay) ---------- */
    const onTouchStart = (e) => {
      e.stopPropagation(); // 👈 IMPORTANT
      startY = e.touches[0].clientY;
      currentY = startY;
      dragging = true;
      panel.style.transition = "none";
    };

    const onTouchMove = (e) => {
      if (!dragging) return;
      e.stopPropagation(); // 👈 IMPORTANT

      currentY = e.touches[0].clientY;
      const diff = currentY - startY;

      if (diff > 0) {
        panel.style.transform = `translateY(${diff}px)`;
      }
    };

    const onTouchEnd = (e) => {
      e.stopPropagation(); // 👈 IMPORTANT
      dragging = false;

      const diff = currentY - startY;

      if (diff > 120) {
        close();
      } else {
        panel.style.transition = "transform 0.3s ease";
        panel.style.transform = "translateY(0)";
      }

      startY = 0;
      currentY = 0;
    };


    panel.addEventListener("touchstart", onTouchStart);
    panel.addEventListener("touchmove", onTouchMove);
    panel.addEventListener("touchend", onTouchEnd);

    overlay.addEventListener("touchstart", onTouchStart);
    overlay.addEventListener("touchmove", onTouchMove);
    overlay.addEventListener("touchend", onTouchEnd);

    return { open, close };
  }

  _initializeOptionsButtonsShow(show = false) {
    const overlay = document.getElementById("nvBusinessOptionsEachCon12A");
    const menu = overlay.querySelector(".nvBusinessOptionsEachCon12");

    if (!overlay || !menu) return;

    const open = () => {
      overlay.classList.add("nvBusinessOptionsEachCon12AView");
    };

    const close = () => {
      overlay.classList.remove("nvBusinessOptionsEachCon12AView");
    };

    // Initial state
    show ? open() : close();

    // Click outside closes
    overlay.addEventListener("click", (e) => {
      if (!menu.contains(e.target)) {
        close();
      }
    });

    return { open, close };
  }

  _initializeListsOptionsButtonsShow(show = false) {
    const overlay = document.getElementById("nvBusinessEachListsOptionsCon12A");
    const menu = overlay.querySelector(".nvBusinessOptionsEachCon12");

    if (!overlay || !menu) return;

    const open = () => {
      overlay.classList.add("nvBusinessOptionsEachCon12AView");
    };

    const close = () => {
      overlay.classList.remove("nvBusinessOptionsEachCon12AView");
    };

    // Initial state
    show ? open() : close();

    // Click outside closes
    overlay.addEventListener("click", (e) => {
      if (!menu.contains(e.target)) {
        close();
      }
    });

    return { open, close };
  }

  _initializeListEditShow(show = false) {
    const overlay = document.getElementById("BusinessEachEditList");
    const backButton = document.getElementById("BusinessEachEditListBackButton");
    const saveButton = document.getElementById("BusinessEachEditListSaveButton");
    const BusinessEachEditListInputName = document.getElementById("BusinessEachEditListInputName");
    const BusinessEachEditListDisplayTag = document.getElementById("BusinessEachEditListDisplayTag");
    const input = document.getElementById('businessCatListImageInput');
    const preview = document.getElementById('businessCatListImageDisp');
    const el = document.getElementById('btnActionBusinessContactShowOptions');

    let targetE = ''

    if (!overlay || !backButton) return;

    const open = (e) => {
      targetE = e

      if (this.#currentListForAction === 'all') {
        alert("No puedes editar la lista de todos los listados.");
        return
      }

      this.#catagoryImageChanged = false

      overlay.style.display = "flex"
      let tagName = this.#currenBusinessData.categories
        ?.find(cat => cat.machine === this.#currentListForAction)
        ?.name
        ?? this.#currentListForAction
      let tagImage = this.#currenBusinessData.categories
        ?.find(cat => cat.machine === this.#currentListForAction)
        ?.image?.res_500
        ?? B3B3B3

      BusinessEachEditListInputName.value = tagName
      BusinessEachEditListDisplayTag.textContent = this.#currentListForAction
      preview.src = tagImage
    };

    const close = () => {
      overlay.style.display = "none"
    };
    const save = async () => {
      try {
        const name = BusinessEachEditListInputName.value.trim();
        console.log('saving list changes');
        if (name.length > 50) {
          alert("El nombre de la lista no puede tener más de 50 caracteres.");
          return
        }

        let category = this.#currenBusinessData.categories
          ?.find(cat => cat.machine === this.#currentListForAction)
          ?? null

        if (!category) return


        let img = category.image
        console.log(category);
        console.log(this.#catagoryImageChanged);


        spinner._displaySpinner("Subiendo imágenes");
        img = await FireBaseHelperOwn._uploadImagesAndGetReferences(
          "businessCatListImageDispParentCon", 'imageProgressCon', false, 'public/tempUploads/'
        );
        console.log(img);



        spinner._displaySpinner("Actualizando lista");
        const dataSend = {
          machine: this.#currentListForAction,
          name: name,
          isNewImage: this.#catagoryImageChanged,
          image: img[0].res_original,
          businessId: this.#currenBusinessData.businessId,
          adminImgPath: `public/businesses/${this.#currenBusinessData.businessId}`
        }
        console.log(dataSend);
        if (!dataSend.image) {
          alert("Debes seleccionar una imagen para la lista.");
          return
        }
        console.log(dataSend);

        const updateResult = await firebase._NVEditBusinessCatLists(dataSend)

        if (updateResult.data.success) {
          close();
          console.log(el);
          StackDisplay._goBackOnStack(targetE, el)

          allHandeling._displayTheRightWay(this.#currenBusinessData.businessId, null, 'business', null, null, null, null, this.#currentListForAction);

          // this._init(this.#currenBusinessData, false, this.#currentListForAction);
          alert("Lista actualizado correctamente.");
        } else {
          alert(
            `Hubo un error al actualizar esta lista. Error: ${resultUploadListing.data.message}`
          );
        }


        console.log(name);
      } catch (error) {

      } finally {
        spinner._hideSpinner();
      }
    };

    // Initial state
    show ? open() : close();


    if (!this.#editListsEventsInitialized) {
      this.#editListsEventsInitialized = true;


      backButton.addEventListener("click", () => {
        close();
      });
      saveButton.addEventListener("click", () => {
        save();
      });

      input.addEventListener('change', () => {
        this.#catagoryImageChanged = true;
        const file = input.files[0];
        if (!file) return;

        // ensure it's an image
        if (!file.type.startsWith('image/')) return;

        const reader = new FileReader();

        reader.onload = (e) => {
          preview.src = e.target.result;
        };

        reader.readAsDataURL(file);
      });
    }

    return { open, close };
  }



  async _init(businessData, share, list = 'all') {

    if (!businessData) return
    console.log("Display Business Each Init called");
    this.#currenBusinessData = null;
    this.#currentCategory = null
    this.#interaction = false;


    if (list !== 'all') {
      this.#currentCategory = list
    }

    if (this.#currentBusinessId === businessData?.businessId) {
      return;
    }


    this.#currentBusinessId = businessData?.businessId;
    setTimeout(() => {
      this.#currentBusinessId = null;
    }, 2000);


    this.#account = firebase._getLatestCurrentUserData();
    this.#bottomScrollDetectOnBusinessDisplayConActivated = false;
    this.#wasFinalDocForLoad = false;

    console.log(businessData);
    this.#currenBusinessData = businessData;
    console.log(this.#currenBusinessData);
    const thisBusinessUniqueId = GENRALHELPERS._getUniqueIdfunction();
    spinner._displaySpinner("Cargando negocio");
    console.log("called");

    const allHtmlForBusiness = generateHtml._generateBusiness(
      businessData,
      thisBusinessUniqueId, list
    );
    StackDisplay._display(allHtmlForBusiness);
    this._loadMoreBusinessListings(true);


    firebase._updateViewsOnBusiness({ businessId: businessData.businessId });
    spinner._hideSpinner();
    this._businessEvents();
    this._onContainerScroll('nvBusinessEachCon1A')
    this.#contactInfoDispFunction = this._initializeContactButtonsShow(false);
    this.#optionsDispFunction = this._initializeOptionsButtonsShow(false);
    this.#listsOptionsDispFunction = this._initializeListsOptionsButtonsShow(false);
    this.#listsEditDispFunction = this._initializeListEditShow(false);


    // setTimeout(() => {
    //   contactInfo.open();
    // }, 5000)
    this._activateTheRightCategoryButtonInBusiness(list);


    const historySaveUrl = await GENRALHELPERS._createUrlForSharing(
      businessData.businessId,
      null,
      null,
      null
    );

    const historyData = {
      href: historySaveUrl,
      title: businessData.name || 'Negocio sin nombre',
      image: businessData?.images?.profile[0]?.res_200 || '',
      type: 'business', // item | category | search
    }

    GENRALHELPERS._pushUserHistory(historyData)

    this._fadeTargetNearTop('nvBusinessEachCon20AB', 'BnvBusinessEachCon3');


  }



  // _fadeTargetNearTop(elementId, targetElId) {

  //   const element = document.getElementById(elementId);
  //   const targetEl = document.getElementById(targetElId);

  //   console.log(element, targetElId);

  //   const fadeDistance = 99;
  //   const minOpacity = 0.01;

  //   const updateOpacity = () => {
  //     const { top } = element.getBoundingClientRect();

  //     // 0 at/above the top, 1 when 99px or farther away
  //     const progress = Math.max(0, Math.min(top / fadeDistance, 1));
  //     console.log('progress', progress);

  //     // Never reaches zero
  //     const opacity = minOpacity + (1 - minOpacity) * progress;

  //     targetEl.style.opacity = opacity;
  //     targetEl.style.pointerEvents = progress <= 0 ? "none" : "auto";
  //   };

  //   updateOpacity();

  //   window.addEventListener("scroll", updateOpacity, { passive: true });
  //   window.addEventListener("resize", updateOpacity, { passive: true });

  //   // Return this so you can remove listeners if the UI is destroyed.
  //   return () => {
  //     window.removeEventListener("scroll", updateOpacity);
  //     window.removeEventListener("resize", updateOpacity);
  //   };
  // }

  _fadeTargetNearTop(elementId, targetElId) {
    const element = document.getElementById(elementId);
    const targetEl = document.getElementById(targetElId);

    if (!element || !targetEl) {
      console.warn("Element not found:", { elementId, targetElId });
      return;
    }

    targetEl.style.transition = "opacity 80ms linear, transform 180ms ease";

    const fadeDistance = 99;
    const triggerOffset = 2;
    const minOpacity = 0.35;

    const updateOpacity = () => {
      const elementTop = element.getBoundingClientRect().top;

      // Fully faded at 2px from the top.
      const progress = Math.min(
        1,
        Math.max(0, (elementTop - triggerOffset) / fadeDistance)
      );

      targetEl.style.opacity =
        minOpacity + (1 - minOpacity) * progress;

      targetEl.style.pointerEvents =
        progress <= 0 ? "none" : "auto";

      // Move left when it reaches the 2px trigger point.
      targetEl.style.transform =
        progress <= 0 ? "translateX(-40px)" : "translateX(0)";
    };

    updateOpacity();

    // Captures scroll events from window AND any scrollable parent.
    document.addEventListener("scroll", updateOpacity, {
      passive: true,
      capture: true
    });

    window.addEventListener("resize", updateOpacity, { passive: true });

    return () => {
      document.removeEventListener("scroll", updateOpacity, true);
      window.removeEventListener("resize", updateOpacity);
    };
  }



  async _fillInBusinessListings(businessData, listingDirectionIds) {
    const listings = await firebase._getAllDocsFromPathByMostRecent(
      `businesses/${businessData.businessId}/listings`,
      true
    );

    const fillInListings = async (listings, id) => {
      const containerForListingsInput = document.getElementById(id);
      for (const listing of listings) {
        const html = await displayListingGenerateHtml._listingVertical(
          listing,
          businessData.colors,
          "listingInBusiness",
          businessData.businessId,
          true,
          "business"
        );
        containerForListingsInput.insertAdjacentHTML("beforeend", html);
      }
    };

    listingDirectionIds.forEach(async (list) => {
      let currentLisitngs = [];

      // Check if list is a All list
      if (list.listType === "todos") {
        listings.forEach((listing) => {
          console.log("got taken for All listings");
          currentLisitngs.push(listing);
        });
        fillInListings(currentLisitngs, list.listId);
      }

      // Check if list is a manual list
      if (list.listType === "manual") {
        if (list.listingsIds) {
          listings.forEach((listing) => {
            if (list.listingsIds.includes(listing.id)) {
              console.log("got taken for manual");
              currentLisitngs.push(listing);
            } else {
              console.log("not taken for manual");
            }
          });
          console.log(currentLisitngs);
          fillInListings(currentLisitngs, list.listId);
        }
      }

      // Check if list is a auto list
      if (list.listType === "auto") {
        // Check if list is a discount list
        if (list.listTag === "en oferta") {
          listings.forEach((listing) => {

            if (listing?.onDiscount?.amount > 0) {
              currentLisitngs.push(listing);
            }
          });
          fillInListings(currentLisitngs, list.listId);
        } else {
          console.log("got here");
          listings.forEach((listing) => {
            if (listing.listingMachineType === list.listTag) {
              currentLisitngs.push(listing);
            }
          });
          console.log(currentLisitngs);
          fillInListings(currentLisitngs, list.listId);
        }
      }
    });
  }

  async _displayLists(listName, business) {
    let htmlToReturn;
    const htmlContainerId = GENRALHELPERS._getUniqueIdfunction();

    try {
      htmlToReturn = displayListingGenerateHtml._businessPackOfPacks(
        displayListingGenerateHtml._listingPack(
          listName,
          business.colors,
          htmlContainerId
        )
      );

      return [htmlToReturn, htmlContainerId];
    } catch (err) {
      if (err.name === "AbortError") {
        console.log("Display For You aborted.");
      } else {
        console.error(err);
      }
    }
  }

  // Start Making an image
  async _captureElementScreenshot(elementCl) {
    const elementForImgGeting = document.querySelector(
      `.BusinessViewEachHeaderCon1`
    );
    const element = document.querySelector(`.${elementCl}`);
    if (!element) {
      throw new Error("Element not found");
    }
    const imgUrl = elementForImgGeting.querySelector("img").src;
    console.log(imgUrl);

    function setBackgroundImage(element, imageUrl) {
      if (!element || !imageUrl) {
        console.error("Element or image URL is missing");
        return;
      }

      // Set the background image and styles
      element.style.backgroundImage = `url('${imageUrl}')`;
      element.style.backgroundSize = "cover";
      element.style.backgroundRepeat = "no-repeat";
      element.style.backgroundPosition = "center";

      //   Add some more
    }
    setBackgroundImage(element, imgUrl);

    // Ensure the element is styled properly for rendering
    const originalStyle = element.style.cssText;

    // Set inline styles to ensure full rendering
    element.style.paddingBottom = "6px";
    element.style.width = "300px";
    element.querySelector(".addForShareText").style.display = "flex";

    try {
      // Use html2canvas to capture the element
      const canvas = await html2canvas(element, {
        useCORS: true, // Allows cross-origin images
        backgroundColor: null, // Ensures the background is captured as it is
        scale: 5, // Improves resolution of the captured image
      });

      // Convert the canvas to a Blob
      const blob = await new Promise((resolve) =>
        canvas.toBlob(resolve, "image/png")
      );

      if (!blob) {
        throw new Error("Failed to create Blob from canvas");
      }

      // Optionally, create a URL and trigger a download
      const url = URL.createObjectURL(blob);
      //   const link = document.createElement("a");
      //   link.href = url;
      //   link.download = "screenshot.png";
      //   document.body.appendChild(link);
      //   link.click();
      //   document.body.removeChild(link);
      //   URL.revokeObjectURL(url);

      //   Return the Blob for further use
      return url;
      //   return blob;
    } catch (error) {
      console.error("Error capturing element screenshot:", error);
      throw error;
    } finally {
      // Restore the original styles
      element.style.cssText = originalStyle;
      element.style.backgroundImage = ``;
      element.querySelector(".addForShareText").style.display = "none";
    }
  }
  // End Making an image

  _filterListingsByTokens(listings, tokens) {
    // Ensure tokens are unique for efficient lookup
    const tokenSet = new Set(tokens);

    // Filter listings based on whether any token matches
    return listings.filter((listing) => {
      if (!Array.isArray(listing.listingTokens)) return false; // Skip listings without valid tokens
      return listing.listingTokens.some((token) => tokenSet.has(token));
    });
  }

  _shareActionForBusiness = async (target) => {
    const getUrlToCurrentBusiness = async () => {
      const parentForData = target.closest(".ActionForShare");
      const businessName = parentForData.dataset.businessname;
      const businessId = parentForData.dataset.businessid;
      console.log(businessId);
      const url = await GENRALHELPERS._createUrlForSharing(
        businessId,
        businessName
      );
      return url;
    };

    const ButtonActionShare = target.closest(
      "#BusinessViewEachUserActionsCon6Share"
    );
    const parentEL = ButtonActionShare.closest(".ActionForShare");
    const businessId = parentEL.dataset.businessid;
    const businessName = parentEL.dataset.businessname;
    const businessShortDescription = parentEL.dataset.businessshordescription;

    const imgBlob = await this._captureElementScreenshot(
      "BusinessViewEachHeaderCon8"
    );

    const businessUrl = await getUrlToCurrentBusiness();
    const textForBusinessName = "```" + businessName + "```";
    const textForDescription = "``" + businessShortDescription + "``";

    const descriptionForBusinessShare = `*${businessName}*\n${textForDescription}\n\n*Visita este negocio en:* _${businessUrl}_\n\n *Visita nuestro mercado de maquinaria agricola e industrial en:* _https://maquinariasonline.com_\n\n🔗 *COMPARTE*`;

    const sharingResult = await GENRALHELPERS._shareImagesWithText(
      businessName,
      descriptionForBusinessShare,
      [imgBlob]
    );
    if (sharingResult.success) {
      firebase._updateSharesOnBusiness({ businessId: businessId });
    }
  };

  // new start here
  async _contactWhatsApp(id) {
    const businessName = this.#currenBusinessData.name;
    const businessId = this.#currenBusinessData.businessId;
    const url = await GENRALHELPERS._createUrlForSharing(
      businessId,
      businessName
    );
    console.log(this.#currenBusinessData);
    const openWhatsApp = (phoneNumber, message) => {
      try {
        // Encode the phone number and message for URL safety
        const encodedMessage = encodeURIComponent(message);
        const whatsappUrl = `https://wa.me/+52${phoneNumber}?text=${encodedMessage}`;
        GENRALHELPERS._openOutboundLink(whatsappUrl)
        return
        // Open the WhatsApp link in a new tab or current tab
        window.open(whatsappUrl, "_blank");

        console.log("WhatsApp link opened:", whatsappUrl);
      } catch (error) {
        console.error("Error creating or opening WhatsApp link:", error);
      }
    };

    const message = `${GENRALHELPERS._getSpanishGreetingForDay()}, *${businessName}*.\nLes estoy contactando desde ${url}\n\n*Mesaje:*`;

    openWhatsApp(this.#currenBusinessData.contacts.whatsApp.contact, message);
  }
  _call(id) { }
  async _share(id) {
    const businessName = this.#currenBusinessData.name;
    const businessId = this.#currenBusinessData.businessId;
    const businessShortDescription =
      this.#currenBusinessData.businessShortDescription;

    console.log(businessId, id);

    if (businessId !== id) {
      alert(
        "Hay un error en identificar este negocio. Por favor cierra este negocio y ábrelo de nuevo."
      );
      return;
    }

    const getUrlToCurrentBusiness = async () => {
      console.log(businessId);
      const url = await GENRALHELPERS._createUrlForSharing(
        businessId,
        businessName
      );
      return url;
    };

    const currentBusiness = await getUrlToCurrentBusiness();

    shareNow._open(
      { business: this.#currenBusinessData, businessUrl: currentBusiness },
      "business"
    );
  }

  async _shareList(id) {
    if (this.#currentListForAction === 'all') { this._share(id); return }
    const businessName = this.#currenBusinessData.name;
    const businessId = this.#currenBusinessData.businessId;
    console.log(businessId, id);

    if (businessId !== id) {
      alert(
        "Hay un error en identificar este negocio. Por favor cierra este negocio y ábrelo de nuevo."
      );
      return;
    }

    const getUrlToCurrentBusiness = async () => {
      console.log(businessId);
      const url = await GENRALHELPERS._createUrlForSharing(
        businessId,
        businessName
      );
      return url;
    };

    const currentBusiness = await getUrlToCurrentBusiness() + `&lista=${this.#currentListForAction}`;
    console.log(currentBusiness);

    shareNow._open(
      { business: this.#currenBusinessData, businessUrl: currentBusiness },
      "business list", this.#currentListForAction
    );
  }

  async _editList(id, e) {
    this.#listsEditDispFunction.open(e)
    return
    if (this.#currentListForAction === 'all') { this._share(id); return }
    const businessName = this.#currenBusinessData.name;
    const businessId = this.#currenBusinessData.businessId;
    console.log(businessId, id);

    if (businessId !== id) {
      alert(
        "Hay un error en identificar este negocio. Por favor cierra este negocio y ábrelo de nuevo."
      );
      return;
    }

    const getUrlToCurrentBusiness = async () => {
      console.log(businessId);
      const url = await GENRALHELPERS._createUrlForSharing(
        businessId,
        businessName
      );
      return url;
    };

    const currentBusiness = await getUrlToCurrentBusiness() + `&lista=${this.#currentListForAction}`;
    console.log(currentBusiness);

    shareNow._open(
      { business: this.#currenBusinessData, businessUrl: currentBusiness },
      "business list", this.#currentListForAction
    );
  }

  async _save(id) {
    const btnActionBusinessSave = document.getElementById(
      "btnActionBusinessSave"
    );
    const businessId = this.#currenBusinessData.businessId;
    const account = firebase._getLatestCurrentUserData();
    if (account) {
      console.log("clicked");

      let path = `businesses/${businessId}`;

      const saveObj = {
        path: path,
        time: GENRALHELPERS._getTimeStampJS(),
      };

      btnActionBusinessSave.insertAdjacentHTML(
        "beforeend",
        this._returnMiniSpinner()
      );

      console.log(businessId);

      const saveResult = await firebase._updateSavesOnBusiness({
        businessId: businessId,
      });

      if (saveResult.data.status === "success") {
        if (saveResult.data.action === "saved") {
          handleAccount._getAccountState();
          btnActionBusinessSave.querySelector("img").src = iconBlackSaved;
          btnActionBusinessSave.querySelector(".nvBusinessOptionsEachText14").textContent = "Quitar Guardado";
          btnActionBusinessSave.querySelector(".miniSpinneForButtons").remove();
        }
        if (saveResult.data.action === "removed") {
          handleAccount._getAccountState();
          btnActionBusinessSave.querySelector("img").src = iconBlackSave;
          btnActionBusinessSave.querySelector(".nvBusinessOptionsEachText14").textContent = "Guardar";
          btnActionBusinessSave.querySelector(".miniSpinneForButtons").remove();
        }
      }
    } else {
      register._displayOptions(
        null,
        "Para guardar un negocio tienes que tener una cuenta activa en este dispositivo."
      );
    }
  }
  _info(what, id) {
    const nvBusinessInfoEachCon12A = document.getElementById(
      "nvBusinessInfoEachCon12A"
    );
    if (what === "show") {
      nvBusinessInfoEachCon12A.style.display = "flex";
    }
    if (what === "hide") {
      nvBusinessInfoEachCon12A.style.display = "none";
    }
  }

  _loadSpecificCategoryInBusiness(cat) {
    console.log(cat);
    this.#wasFinalDocForLoad = false;
    this.#lastVisibleDocForBusinessListings = null;
    this.#currentCategory = cat;
    if (cat === "all") {
      this.#currentCategory = null;
    }
    this._loadMoreBusinessListings(true);
  }

  async _EditBusinessCall(businessId, e) {
    const businessData = await firebase._getAnyDocById(`businesses/${businessId}`)
    if (!businessData) {
      alert("No podimos cargar tu negocio en este momento. Intenta de nuevo un poco despues.")
      return
    }

    if (e) {

      const mainParent = e.target.closest('.bussinessDisplayCon1')
      const closestBackButton = mainParent.querySelector('.CloseCurrentStackPageButton')

      closestBackButton.click()
    }

    NVBusinessEditor._init(businessData, true)
    console.log('should open business edit');
  }


  // _activateTheRightCategoryButtonInBusiness(cat) {
  //   const categorySelectMainConInBusiness = document.getElementById(
  //     "categorySelectMainConInBusiness"
  //   );
  //   const allCategoryButtons = categorySelectMainConInBusiness.querySelectorAll(
  //     ".nvBusinessEachCon21"
  //   );

  //   allCategoryButtons.forEach((btn) => {
  //     btn.classList.remove("nvBusinessEachCon21Act");
  //     if (btn.dataset.machine === cat) {
  //       btn.classList.add("nvBusinessEachCon21Act");
  //     }
  //     if (cat === 'all' && btn.dataset.machine === 'all') {
  //       btn.classList.add("nvBusinessEachCon21Act");
  //     }
  //   });
  // }

  _activateTheRightCategoryButtonInBusiness(cat) {
    const categorySelectMainConInBusiness = document.getElementById(
      "categorySelectMainConInBusiness"
    );

    const allCategoryButtons =
      categorySelectMainConInBusiness.querySelectorAll(".nvBusinessEachCon21");

    let activeBtn = null;

    allCategoryButtons.forEach((btn) => {

      const text1 = btn.querySelector('.nvBusinessEachText8')
      const text2 = btn.querySelector('.nvBusinessEachText9')

      btn.classList.remove("nvBusinessEachCon21Act");
      text1.classList.remove("nvBusinessEachText8ACT");
      text2.classList.remove("nvBusinessEachText9ACT");

      if (
        btn.dataset.machine === cat ||
        (cat === 'all' && btn.dataset.machine === 'all')
      ) {
        btn.classList.add("nvBusinessEachCon21Act");
        text1.classList.add("nvBusinessEachText8ACT");
        text2.classList.add("nvBusinessEachText9ACT");
        activeBtn = btn;
      }
    });

    // 👇 scroll active button into view
    if (activeBtn) {
      activeBtn.scrollIntoView({
        behavior: 'smooth',
        inline: 'center',
        block: 'nearest'
      });
    }
  }





  async _businessEvents() {
    console.log('Business events active');


    let businessOpenOptionsEvent = null

    const btnActionBusinessEdit = document.getElementById(
      "btnActionBusinessEdit"
    );
    const btnActionBusinessDelete = document.getElementById(
      "btnActionBusinessDelete"
    );

    const btnActionBusinessOptionsShowOptions = document.getElementById(
      "btnActionBusinessOptionsShowOptions"
    );
    const btnActionBusinessContactShowOptions = document.getElementById(
      "btnActionBusinessContactShowOptions"
    );
    const btnActionBusinessContactWhatsApp = document.getElementById(
      "btnActionBusinessContactWhatsApp"
    );
    const btnActionBusinessContactCall = document.getElementById(
      "btnActionBusinessContactCall"
    );
    const btnActionBusinessShare = document.getElementById(
      "btnActionBusinessShare"
    );
    const btnActionBusinessListShare = document.getElementById(
      "btnActionBusinessListShare"
    );
    const btnActionBusinessListEdit = document.getElementById(
      "btnActionBusinessListEdit"
    );
    const btnActionBusinessSave = document.getElementById(
      "btnActionBusinessSave"
    );
    const btnActionBusinessInfo = document.getElementById(
      "btnActionBusinessInfo"
    );
    const businessInfoConForDisplayBtnExit = document.getElementById(
      "businessInfoConForDisplayBtnExit"
    );
    const DisplayBusinessEachInfoPortionWahtsApp = document.getElementById(
      "DisplayBusinessEachInfoPortionWahtsApp"
    );

    const categorySelectMainConInBusiness = document.getElementById(
      "categorySelectMainConInBusiness"
    );
    const allCategoryButtons = categorySelectMainConInBusiness.querySelectorAll(
      ".nvBusinessEachCon21"
    );



    btnActionBusinessEdit.addEventListener("click", (e) => {
      const businessId = e.target.closest(".ActionForShare").dataset.businessid;

      console.log("btnActionBusinessEdit");
      this._EditBusinessCall(businessId, e);
    });


    btnActionBusinessDelete.addEventListener("click", async (e) => {
      try {
        const businessId = e.target.closest(".ActionForShare").dataset.businessid;

        console.log("btnActionBusinessDelete");

        const confirmDelete = confirm('Estás seguro que quieres eliminar este negocio? Esto elimina también todos los listados publicado en este negocio. Esta acción no se puede deshacer.')
        if (!confirmDelete) return

        spinner._displaySpinner('Por favor espera mientras estamos eliminando tu empresa.')

        const { data } = await firebase._NVDeleteBusiness({ businessId })
        console.log(data);

        if (data.status === 'success') {

          const userData = firebase._getLatestCurrentUserData()
          firebase._getUserDataFromBase(userData.userId)

          alert('Tu empresa ha side eliminado con éxito.')

          StackDisplay._goBackOnStack(businessOpenOptionsEvent, btnActionBusinessDelete)
        }
      } catch (error) {
        alert(error)
      } finally {
        spinner._hideSpinner()
      }
    });


    btnActionBusinessContactWhatsApp.addEventListener("click", (e) => {
      const businessId = e.target.closest(".ActionForShare").dataset.businessid;

      console.log("btnActionBusinessContactWhatsApp");
      this._contactWhatsApp(businessId);
    });
    btnActionBusinessContactShowOptions.addEventListener("click", (e) => {
      this.#contactInfoDispFunction.open();
    });
    btnActionBusinessOptionsShowOptions.addEventListener("click", (e) => {

      businessOpenOptionsEvent = e
      this.#optionsDispFunction.open();
    });
    DisplayBusinessEachInfoPortionWahtsApp.addEventListener("click", (e) => {
      console.log("btnActionBusinessContactWhatsAppFromInfo");
      this._contactWhatsApp();
    });
    btnActionBusinessContactCall.addEventListener("click", (e) => {
      const businessId = e.target.closest(".ActionForShare").dataset.businessid;

      console.log("btnActionBusinessContactCall");
      this._call(businessId);
    });
    btnActionBusinessShare.addEventListener("click", (e) => {
      const businessId = e.target.closest(".ActionForShare").dataset.businessid;

      console.log("btnActionBusinessShare");
      this._share(businessId);
      this.#optionsDispFunction.close();
    });
    btnActionBusinessListShare.addEventListener("click", (e) => {
      const businessId = e.target.closest(".ActionForShare").dataset.businessid;

      console.log("btnActionBusinessShare");
      this._shareList(businessId);
      this.#listsOptionsDispFunction.close();
    });
    btnActionBusinessListEdit.addEventListener("click", (e) => {
      const businessId = e.target.closest(".ActionForShare").dataset.businessid;

      this._editList(businessId, e);
      this.#listsOptionsDispFunction.close();
    });
    btnActionBusinessSave.addEventListener("click", (e) => {
      const businessId = e.target.closest(".ActionForShare").dataset.businessid;

      console.log("btnActionBusinessSave");
      this._save(businessId);
    });
    btnActionBusinessInfo.addEventListener("click", (e) => {
      const businessId = e.target.closest(".ActionForShare").dataset.businessid;

      console.log("btnActionBusinessInfo");
      this._info("show", businessId);
      this.#optionsDispFunction.close();
    });
    businessInfoConForDisplayBtnExit.addEventListener("click", (e) => {
      console.log("businessInfoConForDisplayBtnExit");
      this._info("hide");
    });
    categorySelectMainConInBusiness.addEventListener("click", (e) => {
      const isCatButton = e.target.closest('.nvBusinessEachCon21')
      if (!isCatButton) return
      const machine = isCatButton.dataset.machine;
      this._loadSpecificCategoryInBusiness(machine);
      this._activateTheRightCategoryButtonInBusiness(machine);
    });

    if (this.#oneTimeEventsInitialized) return
    this.#oneTimeEventsInitialized = true;

    let pressTimer;

    window.addEventListener('contextmenu', (e) => {
      const isCatButton = e.target.closest('.nvBusinessEachCon21');
      if (!isCatButton) return;

      e.preventDefault(); // 🚫 stop native menu
    });

    window.addEventListener('pointerdown', (e) => {
      const isCatButton = e.target.closest('.nvBusinessEachCon21');
      if (!isCatButton) return;

      e.preventDefault(); // 🔑 THIS is key

      const machine = isCatButton.dataset.machine;
      if (!machine) return;
      this.#currentListForAction = machine

      pressTimer = setTimeout(() => {
        this.#listsOptionsDispFunction.open();
      }, 500);
    });


    window.addEventListener('pointerup', () => {
      clearTimeout(pressTimer);
    });

    window.addEventListener('pointercancel', () => {
      clearTimeout(pressTimer);
    });

    window.addEventListener('pointermove', () => {
      clearTimeout(pressTimer); // cancel if user moves
    });



  }
}

export default new DisplayBusinessEach();
